import GlBaseAnimatedIcon from './base_animated_icon';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'GlAnimatedSmileIcon',
  extends: GlBaseAnimatedIcon
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconStateClass, _vm.iconVariantClass],attrs:{"aria-label":_vm.ariaLabel,"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"gl-animated-smile-eyes"},[_c('circle',{attrs:{"cy":"7","cx":"6","r":"0.5"}}),_vm._v(" "),_c('circle',{attrs:{"cy":"7","cx":"10","r":"0.5"}})]),_vm._v(" "),_c('path',{staticClass:"gl-animated-smile-big-smile",attrs:{"d":"M8 12C9.65685 12 11 10.6569 11 9H5C5 10.6569 6.34315 12 8 12Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{staticClass:"gl-animated-smile-slight-smile",attrs:{"d":"M6.3 10C6.46667 10.3333 7 11 8 11C9 11 9.53333 10.3333 9.7 10","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.25","stroke":"currentColor","stroke-width":"1.5"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
